import config from '../config';

export async function fetchUserRoles(backendFetch) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/roles")
    if (f.status === 403) {
        return []
    }
    const r = await f.json()
    return r.roles ? r.roles : []
}